// extracted by mini-css-extract-plugin
export default {"languageButton":"styles_languageButton__nkX7B"};